import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Main from '@/components/Main'
import Installed from '@/components/Installed'
import Config from '@/components/Config'
// import Login from '@/components/login/Login.vue'
// import Logout from '@/components/login/Logout.vue'
import Page1 from '@/components/pages/Page01'
import Page2 from '@/components/pages/Page02'
import Page3 from '@/components/pages/Page03'
import Page4 from '@/components/pages/Page04'
import Framework from '@/components/Framework'
import FrameworkTest from '@/components/FrameworkTest'
import PGSearch from '@/components/pages/PageSearch'
import PageDownload from '@/components/pages/PageDownload'
import ShopCancel from '@/components/ShopCancel'
import ShopSuccess from '@/components/ShopSuccess'
import Testtabelle from '@/components/pages/Testtabelle'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/',
      name: 'Installed',
      component: Installed
    },
    {
      path: '/Home',
      name: 'Main',
      component: Main
    },
    {
      path: '/Testtabelle',
      name: 'Testtabelle',
      component: Testtabelle
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/ShopSuccess',
      name: 'ShopSuccess',
      component: ShopSuccess
    },
    {
      path: '/ShopCancel',
      name: 'ShopCancel',
      component: ShopCancel
    },
    {
      path: '/Framework',
      name: 'Framework',
      component: Framework
    },
    {
      path: '/FrameworkTest',
      name: 'FrameworkTest',
      component: FrameworkTest
    },
    {
      path: '/Configuration',
      name: 'Config',
      component: Config
    },
    {
      path: '/search',
      name: 'PGSearch',
      component: PGSearch
    },
    {
      path: '/page1',
      name: 'Page1',
      component: Page1
    },
    {
      path: '/page2',
      name: 'Page2',
      component: Page2
    },
    {
      path: '/page3',
      name: 'Page3',
      component: Page3
    },
    {
      path: '/page4',
      name: 'Page4',
      component: Page4
    },
    {
      path: '/download',
      name: 'PageDownload',
      component: PageDownload
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js